import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {updateTermsAndConditions} from 'services/UsersService';

const entityKey = 'userAgreements';

const initialState = {
    result: null,
    loading: false,
    error: '',
};

// genenrates pending, fulfilled and rejected
export const updateTermsOfUseAcceptance = createAsyncThunk(
    `${entityKey}/updateTermsOfUseAcceptance`,
    (record) => {
        return updateTermsAndConditions(record.id).then((response) => {
            const {status} = response;

            if (status !== 204) {
                return false;
            }
            return true;
        });
    }
);

const userAgreementsSlice = createSlice({
                                            name: entityKey,
                                            initialState,
                                            extraReducers: (builder) => {
                                                // RUN UPDATE
                                                builder.addCase(updateTermsOfUseAcceptance.pending, (state) => {
                                                    state.loading = true;
                                                });

                                                builder.addCase(
                                                    updateTermsOfUseAcceptance.fulfilled,
                                                    (state, action) => {
                                                        state.result = 'success';
                                                        state.loading = false;
                                                    }
                                                );

                                                builder.addCase(
                                                    updateTermsOfUseAcceptance.rejected,
                                                    (state, action) => {
                                                        state.loading = false;
                                                        state.error = action.error.message;
                                                    }
                                                );
                                            },
                                        });

export default userAgreementsSlice.reducer;
